import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { updateBio } from '../api';
import detailMessage from '../detailMessage';
import { useLang } from '../LangContext';

interface Props {
  token: string;
  initialBio?: string | null;
}

const BioForm = ({ token, initialBio }: Props) => {
  const { t } = useLang();
  const [bio, setBio] = useState(initialBio || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    setBio(initialBio || '');
  }, [initialBio]);

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setBio(e.target.value);
    if (error) setError('');
    if (success) setSuccess('');
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const res = await updateBio(bio.trim() || null, token);
      setBio(res.bio || '');
      setSuccess(t.bioSaved);
      setTimeout(() => setSuccess(''), 4000);
    } catch (err) {
      setError(detailMessage(err, t.bioSaveFailed));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile-section">
      <h4 className="profile-section-title">{t.bioHeading}</h4>

      {error && <div className="error-message"><strong>{t.errorLabel2}</strong> {error}</div>}
      {success && <div className="success-message"><strong>✓</strong> {success}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="bio">{t.bioLabel}</label>
          <textarea
            id="bio"
            value={bio}
            onChange={handleChange}
            placeholder={t.bioPlaceholder}
            maxLength={500}
            rows={4}
            disabled={saving}
            style={{ resize: 'vertical' }}
          />
          <span className="field-hint">{bio.length}/500</span>
        </div>
        <button type="submit" className="submit-button" disabled={saving}>
          {saving ? t.bioSaving : t.bioSaveButton}
        </button>
      </form>
    </div>
  );
};

export default BioForm;
